module.exports = __webpack_public_path__ + "static/media/PuzzlePaint.9f5a7bb0.png";